var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("role-tab", { attrs: { tabs: _vm.bindCorpUsers } }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left-tab-warp" }, [_c("left-tab")], 1),
        _c("div", { staticClass: "right-wrap" }, [
          _c("div", { staticClass: "right-content" }, [
            _vm._m(0),
            _c("div", { staticClass: "right flex-between" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary", plain: "", size: "small" },
                      on: { click: _vm.gotoSignList }
                    },
                    [_vm._v("去仲裁")]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px", "margin-right": "8px" },
                      attrs: { size: "small" },
                      model: {
                        value: _vm.typeStatus,
                        callback: function($$v) {
                          _vm.typeStatus = $$v
                        },
                        expression: "typeStatus"
                      }
                    },
                    _vm._l(_vm.typeOption, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _c("el-input", {
                    staticStyle: { width: "160px", "margin-right": "8px" },
                    attrs: {
                      size: "small",
                      clearable: true,
                      placeholder: "请输入"
                    },
                    model: {
                      value: _vm.preservationId,
                      callback: function($$v) {
                        _vm.preservationId = $$v
                      },
                      expression: "preservationId"
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px", "margin-right": "8px" },
                      attrs: { size: "small", placeholder: "请选择状态" },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.status,
                        attrs: { label: item.text, value: item.status }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px", "margin-right": "8px" },
                      attrs: { size: "small", placeholder: "请选择出证机关" },
                      model: {
                        value: _vm.orgCode,
                        callback: function($$v) {
                          _vm.orgCode = $$v
                        },
                        expression: "orgCode"
                      }
                    },
                    _vm._l(_vm.instiList, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.queryList } },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.rest } },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "table-warp" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "data-list",
                    style: { "min-height": "64vh" },
                    attrs: {
                      data: _vm.listData,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "订单号",
                        prop: "orderNo",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "文件名称",
                        prop: "presName",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "文件编号",
                        prop: "applyNo",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm.currentAuthUser.corpId ||
                    _vm.currentAuthUser.userType == 1
                      ? _c("el-table-column", {
                          attrs: {
                            label: "出证机关",
                            prop: "orgName",
                            "show-overflow-tooltip": ""
                          }
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "申请人", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.userListFn(scope.row.proposerDTOS)
                                  ) +
                                  "\n                "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "被申请人", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.userListFn(scope.row.respondentDTOS))
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "申请时间", prop: "applyTime" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("formatDate")(scope.row.createTime)
                                  ) +
                                  "\n                "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(_vm._s(_vm.statusFn(scope.row.status)))
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              [1, 7].includes(scope.row.status)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.editFn(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              [1, 8].includes(scope.row.status)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteFn(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              [2].includes(scope.row.status)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelFn(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("取消仲裁")]
                                  )
                                : _vm._e(),
                              [9].includes(scope.row.status)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadFn(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("下载裁决书")]
                                  )
                                : _vm._e(),
                              [7, 8].includes(scope.row.status)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.lookReasonFn(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("查看原因")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _c("no-data", {
                      attrs: { slot: "empty", text: "暂无数据" },
                      slot: "empty"
                    })
                  ],
                  1
                ),
                _vm.listData && _vm.listData.length > 0
                  ? _c(
                      "el-row",
                      { staticClass: "pageation row" },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticStyle: { height: "20px" } })
                        ]),
                        _c(
                          "el-col",
                          { staticClass: "page-flex-end", attrs: { span: 18 } },
                          [
                            _vm.paged.total > 0
                              ? _c("el-pagination", {
                                  attrs: {
                                    "pager-count": 5,
                                    total: _vm.paged.total,
                                    "current-page": _vm.paged.pageNum,
                                    "page-size": _vm.paged.pageSize,
                                    "page-sizes": [10, 20, 50, 100],
                                    layout: "sizes, prev, pager, next, total"
                                  },
                                  on: {
                                    "size-change": _vm.handleSizeChange,
                                    "current-change": _vm.handleCurrentChange,
                                    "update:currentPage": function($event) {
                                      return _vm.$set(
                                        _vm.paged,
                                        "pageNum",
                                        $event
                                      )
                                    },
                                    "update:current-page": function($event) {
                                      return _vm.$set(
                                        _vm.paged,
                                        "pageNum",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c("el-go", {
                              attrs: {
                                "page-size": _vm.paged.pageSize,
                                total: _vm.paged.total
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-toolbar" }, [
      _c("h2", { staticClass: "title" }, [_vm._v("仲裁管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a68c385", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a68c385","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/judicialService/applyArbitration.vue
// module id = 1NB+
// module chunks = 71